// extracted by mini-css-extract-plugin
module.exports = {"app-main":"hJ6eDoDqOe"};